__turbopack_context__.v({
  "cloud": "M8UNxq_cloud",
  "cloudWrapper": "M8UNxq_cloudWrapper",
  "frame": "M8UNxq_frame",
  "house": "M8UNxq_house",
  "houseTree": "M8UNxq_houseTree",
  "inner": "M8UNxq_inner",
  "moon": "M8UNxq_moon",
  "root": "M8UNxq_root",
  "sun": "M8UNxq_sun",
  "sunAnchor": "M8UNxq_sunAnchor",
});
